import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getImagePath } from "../utils/imageUtils";
import Gallery from "../components/Gallery";
import { MdOutlineGroup } from "react-icons/md";
import { GrGallery } from "react-icons/gr";
import { ContactData } from "../data-types/api-client/api-contacts";
interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const AboutUs: React.FC<ContactProps> = ({ contact }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#gallery") {
      setTimeout(() => {
        document.getElementById("gallery")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [location]);

  const images = contact?.contact?.images;

  return (
    <div className="flex flex-col items-center justify-center h-full w-full justify-self-center pb-8 2xl:w-3/4 bg-custom-white">
      <div className="bg-custom-gray flex flex-col justify-self-center items-center h-full md:px-20 sm:px-8 px-4 w-full gap-2 md:gap-8 gap-4 py-0 pb-8">
        {/* Text Container */}
        <div className="flex text-custom-atrament lg:text-left text-center h-full pt-4">
          <div className="flex flex-col gap-3 w-full rounded-md">
            <div className="flex w-full items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-xl text-custom-red bg-custom-white">
                <MdOutlineGroup className="text-xl" />
              </span>

              <h2 className="flex w-full justify-start items-center uppercase text-custom-blue font-semibold text-base">
                Bližšie informácie o nás
              </h2>
            </div>
            <div className="flex w-full flex-col lg:px-8 px-4 py-8 w-full gap-4 bg-custom-white rounded-lg shadow-sm self-stretch">
              <h1 className="xl:text-4xl lg:text-3xl sm:text-4xl text-2xl font-semibold text-custom-blue tracking-wide sm:normal-case uppercase">
                Pridávame stále nové náradie
              </h1>
              <div className="flex flex-col gap-4 lg:text-lg text-md font-roboto items-start justify-start text-start">
                <p>
                  Spoločnosť RENTKOS s.r.o. je novou spoločnosť, zameranou na
                  prenájom stavebného náradia, malej mechanizácie a čistiacej
                  techniky. V našom sortimente nájdu pre seba potrebné náradie a
                  mechanizáciu domáci majstri ako aj profesionáli v oblasti
                  stavebníctva.
                </p>
                <p>
                  Naším zámerom je poskytovať kvalitné služby v oblasti prenájmu
                  stavebnej techniky a flexibilne reagovať na potreby našich
                  stálych aj budúcich zákazníkov. Potreby zákazníkov budeme
                  uspokojovať aj rozširovaním a navyšovaním nášho sortimentu ako
                  aj doplnkových služieb.
                </p>
                <p>
                  Aktuálnu základnú ponuku tvorí ručné elektrické náradie,
                  elektrické generátory, mechanizácia na spracovanie čerstvého
                  betónu, malá mechanizácia na hutnenie zemín a štrkov, čistiaca
                  technika pre domácnosť. V ponuke máme výrobky producentov
                  vysokej kvality, ako sú napríklad Wacker Neuson, Bosch,
                  Kärcher, Makita a Dewalt, Stihl, Tsurumi a Mikasa čo je
                  zárukou spoľahlivosti a výkonu. K vybraným mechanizmom a
                  elektrickému náradiu ponúkame aj prenájom/predaj spotrebného
                  materiálu, kvôli šetreniu nákladov našich zákazníkov.
                </p>
              </div>
            </div>
          </div>
        </div>

        <section
          id="gallery"
          className="flex flex-col w-full bg-custom-gray gap-3 scroll-mt-28"
        >
          <div className="flex w-full items-center gap-2">
            <span className="flex items-center justify-center w-9 h-9 rounded-xl text-custom-red bg-custom-white">
              <GrGallery className="text-md" />
            </span>

            <h2 className="flex w-full justify-start items-center uppercase text-custom-blue font-semibold text-base">
              Galéria
            </h2>
          </div>{" "}
          <div className="flex justify-center w-full items-center py-4 md:py-4 px-2 md:px-4 rounded-lg bg-custom-white border border-custom-blue/10 shadow-sm">
            {images && <Gallery images={images} />}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
